import { render, staticRenderFns } from "./item-info-clipons.vue?vue&type=template&id=1d493e3c&scoped=true"
import script from "./item-info-clipons.vue?vue&type=script&lang=js"
export * from "./item-info-clipons.vue?vue&type=script&lang=js"
import style0 from "./item-info-clipons.vue?vue&type=style&index=0&id=1d493e3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d493e3c",
  null
  
)

export default component.exports